import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {
  DDP_CLIENT_ID_GOOGLE_RESELLER_CLIENT_ID,
  DDP_PRICE_UNIT_SIZE,
  DdpClientProduct,
  EditableClientProducts,
  License
} from './domain';

@Component({
  selector: 'app-google-ddp-price-dialog',
  templateUrl: './google-ddp-price-dialog.component.html',
  styleUrls: ['./google-ddp-price-dialog.component.scss']
})
export class GoogleDdpPriceDialogComponent {

  EditableClientProducts = EditableClientProducts;
  DdpClientProduct = DdpClientProduct;

  clientIdControl = new FormControl(undefined, [Validators.required]);
  clientProductControl = new FormControl(undefined, [Validators.required]);
  priceControl = new FormControl(undefined, [Validators.required, Validators.min(0)]);

  priceForm: FormGroup = new FormGroup({
    clientId: this.clientIdControl,
    clientProduct: this.clientProductControl,
    price: this.priceControl,
  });

  constructor(
    public dialogRef: MatDialogRef<GoogleDdpPriceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public existingData?: License
  ) {
    if (existingData) {
      this.clientIdControl.setValue(existingData.clientId);
      this.clientIdControl.disable();

      this.clientProductControl.setValue(existingData.clientProduct);
      this.clientProductControl.disable();

      this.priceControl.setValue(existingData.cost / DDP_PRICE_UNIT_SIZE);
    }
  }

  get unchanged() {
    return this.existingData?.cost === this.priceControl.value * DDP_PRICE_UNIT_SIZE;
  }

  onConfirm(): void {
    const licensee: License = {
      clientId: this.clientIdControl.value,
      clientProduct: this.clientProductControl.value,
      ...this.existingData,
      cost: this.priceControl.value * DDP_PRICE_UNIT_SIZE
    } as License;
    this.dialogRef.close(licensee);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  productChangeHandler(value: string) {
    if (value === DdpClientProduct.RESELLER) {
      this.clientIdControl.setValue(DDP_CLIENT_ID_GOOGLE_RESELLER_CLIENT_ID);
      this.clientIdControl.disable();
    } else {
      this.clientIdControl.setValue('');
      this.clientIdControl.enable();
    }
  }
}
